import { ColdIcon, WarmIcon, HotIcon } from "/src/components/lead-inventory/icons";
import { AccountDetailsSquareSkeleton } from "./skeleton/AccountDetailsSkeleton";

export  default function AccountDetailsSquare({leadDetails}) {

    const leadSourceLabels = {
      0: "Raw Lead",
      1: "Fresh Lead",
      2: "Profile Completed",
      3: "Meeting Completion",
      4: "Onboarded",
      5: "Activated",
      6: "Rejected",
      11: "Tanked",
    };
  
    const interestLevelLabels = {
        1: "Cold",
        2: "Warm",
        3: "Hot",
    };
  
    const getStatusStyle = (status) => {
      const styles = {
          0: "bg-[#FEFAD8] border-[#FEFAD8] text-black",
          1: "bg-[#FEFAD8] border-[#FEFAD8] text-black",
          2: "bg-[#BEC2FF] border-[#BEC2FF] text-[#262BC6]",
          3: "bg-[#E3F3FF] border-[#E3F3FF] text-[#00658E]",
          4: "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
          5: "bg-[#E7FFD6] border-[#E7FFD6] text-[#116D26]",
          6: "bg-red-100 text-red-500",
          11: "bg-red-200 text-red-800"
      };
      return styles[status] || "bg-gray-100 text-gray-600";
    };
    const getLeadStatusStyle = (status) => {
      const styles = {
          Active: "bg-[#FEFAD8] border-[#FEFAD8] text-black",
          Ongoing: "bg-[#FFEEDC] border-[#FFEEDC] text-[#A96900]",
          Inactive: "bg-[#EEEEEE] border-[#EEEEEE] text-[#757575]",
          Tanked: "bg-[#757575] border-[#757575] text-[#EEEEEE]"
      };
      return styles[status] || "bg-gray-100 text-gray-600";
    };
  
    const cards = [
      { title: "Fresh Lead", status: "completed", statusLabel: "Completed" },
      { title: "Profile Completion", status: "in-progress", statusLabel: "In Progress" },
      { title: "Meeting Completion", status: "not-started", statusLabel: "Not Started" },
      { title: "Conversion", status: "not-started", statusLabel: "Not Started" },
    ];
  
    // Render nothing if leadDetails is null
    if (!leadDetails) {
        return <AccountDetailsSquareSkeleton />

    }
  
    return (
      <div className="w-full">
        {/* Outer White Container */}
        <div className="bg-white rounded-2xl md:rounded-3xl shadow-sm p-4 md:p-6 mx-2 md:mx-8 mt-3 md:mt-5">
          <p className="font-light ml-1 text-xs md:text-sm">Account #{leadDetails?.lead_id}</p>
          <p className="font-extrabold text-xl md:text-4xl mt-2 mb-4 md:mb-5 ml-1 break-words"><b>{leadDetails?.name || "Unknown Company"}</b></p>
  
          <div className="flex flex-row gap-2 overflow-x-auto scrollbar-hide pb-2">
            <span className={`w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-3 md:px-5 gap-1 md:gap-2 rounded-full border font-bold text-xs md:text-sm flex-shrink-0 ${getStatusStyle(leadDetails.status)}`}>
                {leadSourceLabels[leadDetails?.status] || "Unknown"}
            </span>
            <span className={`w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-3 md:px-5 gap-1 md:gap-2 rounded-full border font-bold text-xs md:text-sm flex-shrink-0 ${getLeadStatusStyle(leadDetails?.lead_status)}`}>
                {leadDetails?.lead_status}
            </span>
            <span className="w-auto h-[36px] md:h-[40px] py-1.5 md:py-2 px-3 md:px-5 gap-1 md:gap-2 flex items-center rounded-full font-bold text-xs md:text-sm text-[#1E293B] flex-shrink-0">
                {leadDetails?.interest_level === 1 && <img src={ColdIcon} alt="Cold" className="w-5 h-5 md:w-6 md:h-6 inline-block" />}
                {leadDetails?.interest_level === 2 && <img src={WarmIcon} alt="Warm" className="w-5 h-5 md:w-6 md:h-6 inline-block" />}
                {leadDetails?.interest_level === 3 && <img src={HotIcon} alt="Hot" className="w-5 h-5 md:w-6 md:h-6 inline-block" />}
            </span>
          </div>
        </div>
      </div>
    );
  };
      